export const SINGLE_MODE = 'singleMode';
export const MINIMAL_UI = 'minimalUI';
export const MOCK_DATA = 'mockdata';
export const EMBED_MODE = 'embedmode';
export const HIDE_WATERMARK = 'hidewatermark';
export const SHOW_HIDDEN = 'showhidden';
export const SHOW_EM = 'showem';
export const REGION = 'region';
export const DRILL_DOWN = 'drillDown';
export const DRILL_DOWN_STOP = 'drillDownStop';
export const ORIGIN_ROUTE = 'originRoute';

export const ROUTE_DOMAIN = {
  ERM: 'ERM',
  TEM: 'TEM',
  CAASM: 'CAASM'
};
export const ERM_DOMAINS = [ROUTE_DOMAIN.ERM];
export const TEM_DOMAINS = [ROUTE_DOMAIN.TEM];
export const CAASM_DOMAINS = [ROUTE_DOMAIN.CAASM];
export const ALL_DOMAINS = Object.values(ROUTE_DOMAIN);

export const ONLINE_HELP_ROOT = '/online-help';
export const ONLINE_HELP_DETAILS = `${ONLINE_HELP_ROOT}/details`;
export const ONLINE_HELP_LATEST_RELEASE_NOTES = `${ONLINE_HELP_DETAILS}?module=Latest%20Release`;

export const TEM = 'tem';
// Pre-rename prefix, kept so existing bookmarks and deep links still resolve.
export const TEM_LEGACY = 'veriti';
export const CYCLOPS = 'caasm';
export const CYCLOPS_INTEGRATIONS = 'caasm-integrations';
export const ASM_INTEGRATIONS = 'asm-integrations';
export const ERM_INTEGRATIONS = 'erm-integrations';
export const CREATE = 'create';
export const OLD_INDICATOR_TAB = 'indicator';
export const INDICATOR_TAB = 'intel-item';
export const CVE_INDICATOR_TAB = 'cve-intel-item';
export const SUPPLY_CHAIN_INDICATOR_TAB = 'supply-chain-intel-item';
export const NEWS_INDICATOR_TAB = 'news-intel-item';
export const ENTITY_TAB = 'entity';
export const SEARCH_TAB = 'search';
export const GLOBAL_SEARCH_TAB = 'global-search';
export const TI_EVENTS_TAB = 'raw-intel';
export const CUSTOMER_TAB = 'customer-management';
export const CUSTOMER_NEW = 'new';
export const CUSTOMER_CONVERTION = 'convert-to-production';
export const FORENSICS_TAB = 'forensics';
export const FORENSICS_OPEN = 'open-investigation';
export const REPORT_TAB = 'report';
export const REPORT_PREVIEW = 'preview';
export const ACCOUNT = 'account';
export const RI_DASHBOARD = 'ri-dashboard';
export const GENERAL = 'general';
export const CUSTOMER_FILTERED_VIEW = 'filtered-view';
export const ALERTS_TAB = 'alerts';
export const ALERTS_NG_TAB = 'alerts';
export const ALERT_BY_ID = 'alert';
export const ALERT_OLD_BY_ID = 'alert-old';
export const ALERT_CREATE = 'create';
export const CLONE_ALERT = 'clone';
export const ALERT_UPDATE = 'update';
export const STRATEGIC_INTELLIGENCE = 'strategic-intelligence';
export const OPERATIONAL_DASHBOARD_TAB = 'operational-dashboard';
export const EXECUTIVE_DASHBOARD_TAB = 'executive-dashboard';
export const EXECUTIVE_COVERAGE_ROUTE = 'coverage';
export const EXECUTIVE_FINDINGS_ROUTE = 'findings';
export const RISK_DASHBOARD_TAB = 'risk-dashboard';
export const WIDGET = 'widget';
export const RELATED = 'related';
export const NEWS_TICKER_TAB = 'news-ticker';
export const LOOKALIKE_DOMAIN_TAB = 'lookalike-domain';
export const CVE_TAB = 'cve';
export const CVE_NG_TAB = 'cve-ng';
export const THREAT_READINESS_TAB = 'threat-readiness';
export const IOC_MGMT_TAB = 'ioc-mgmt';
export const CARD = 'card';
export const KB_TAB = 'malwares-kb';
export const MALWARE_KB_TAB = 'malwares-kb';
export const THREAT_ACTORS_TAB = 'threat-actors';
export const THREATCLOUD_FEED_TAB = 'threatcloud-intelligence-feed';
export const KNOWLEDGE_HUB_TAB = 'knowledge-hub';
export const INTEGRATIONS_HUB_TAB = 'integrations-hub';
export const CYBER_NEWS_ATTACKS_TAB = 'cyber-news-attacks';
export const VENDORS_TAB = 'vendors';
export const CYBERINT_NEWS_TAB = 'security-news';
export const CYBER_NEWS_TAB = 'cyber-news';
export const BRAND_CONFIGURATION_TAB = 'brand-configuration';
export const BRAND_LOGOS_PATH = 'logos';
export const BRAND_FAVICONS_PATH = 'favicons';
export const BRAND_RESOURCES_PATH = 'resources';
export const CREATE_INDICATOR = 'create-indicator';
export const KNOWLEDGE_BASE_TAB = 'knowledge-base';
export const NOTIFICATIONS_MANAGER_TAB = 'notifications-manager';
export const DIGITAL_FOOTPRINT_TAB = 'my-digital-footprint';
export const ASM_TAB = DIGITAL_FOOTPRINT_TAB;
export const DIGITAL_FOOTPRINT_ASSETS = 'assets';
export const DIGITAL_FOOTPRINT_ISSUES = 'issues';
export const TELEGRAM_TAB = 'telegram';
export const DISCORD_TAB = 'discord';
export const THREAD_VIEW_TAB = 'thread-view';
export const WORKBENCH_TAB = 'threat-landscape';
export const VENDOR_INVENTORY_TAB = 'vendor-inventory';
export const VENDOR_INVENTORY_CREATE = 'create';
export const HOME_DASHBOARD_TAB = 'ri-dashboard';
export const INTELLIGENCE_ARCHIVE_TAB = 'intel-archive';
export const ENV_SUMMARY_TAB = 'mssp-view';
export const AUTOMATED_TAKEDOWN_TAB = 'automated-takedown';
export const CREDENTIAL_PURCHASED_TAB = 'credentials-purchased';
export const SOCIAL_MEDIA_FAKE_PAGES_TAB = 'smfp';
export const ASM_REVAMP_TAB = 'asm';
export const INVESTIGATION_TAB = 'investigation';
export const INVESTIGATIONS_TAB = 'investigations';
export const LEAKED_CREDENTIALS_TAB = 'leaked-credentials';
export const INCIDENTS_TAB = 'incidents';
export const FILES_ANALYZER_TAB = 'files-analyzer';
export const THREAT_EMULATION_TAB = 'threat-emulation';
export const AI_REVERSER_ROUTE = 're-report';
export const AUDIT_LOG = 'audit-log';
export const ASM_TECHNOLOGIES = 'technologies';
export const ASM_CERTIFICATES = 'certificates';
export const EXPOSED_INTERFACES = 'exposed-interfaces';
export const ASM_CREATE = 'create';
export const ASM_ASSETS = 'assets';
export const ASSET_CARD = 'asset-card';
export const ISSUE_CARD = 'card';
export const ASM_EXPOSURE_ITEMS = 'exposure-items';
export const DISCOVER_ASSETS = 'discover';
export const TAKEDOWN_CARD = 'takedown-info';
export const TAKEDOWN_CREATE = 'create';
export const IMPACTOMETER = 'impact-o-meter';
export const IMPACTOMETER_AUTOMATION = 'automation';
export const IMPACTOMETER_CLIENT_HEALTH = 'client-health';
export const IMPACTOMETER_CLIENT_HEALTH_CUSTOMER_CARD = 'customer-info';
export const CAMPAIGNS_TAB = 'campaigns';
export const BLAST_TAB = 'blast';
export const BLAST_SCANS_TAB = 'blast-scans';

export const ADD_COMPANY_FOR_DEMO = 'add-company-for-demo';
export const ADD_TECHNOLOGY = 'add-technology';
export const EDIT_TECHNOLOGY = 'edit-technology';

// user settings routes
export const USER_SETTINGS_TAB = 'user-settings';
export const ACCOUNT_SETTINGS = `${USER_SETTINGS_TAB}/account`;
export const NOTIFICATION_SETTINGS = `${USER_SETTINGS_TAB}/notification`;
export const USER_PERMISSIONS = `${USER_SETTINGS_TAB}/permissions`;
export const USER_RESET = `user-reset-password`;
export const USER_REGISTRATION = `user-registration`;
// customer
export const ASSETS = 'assets';
export const ASSETS_MANAGEMENT_PATH = 'assets-management';
export const CONFIGURED_ASSETS_OLD = 'configured-assets';
export const TI_ASSETS = 'ti-assets';
export const TI_ASSETS_RECOMMENDATIONS = 'assets-recommendations';
export const ASSET_OWNER_MANAGEMENT = 'assets-owner-management';
export const OWNER_CREATE = 'create';
export const OWNER_UPDATE = 'update';
export const ASSET_CREATION = 'creation';
export const ASSET_UPLOAD = 'upload';

export const ALERT_CONFIGURATIONS = 'alert-configurations';

export const ALERT_MAIN_CONFIG = 'config';
export const ALERT_WEBHOOKS_CONFIG = 'alert-webhooks-configuration';
export const ALERT_INTEGRATIONS_CONFIG = 'ad-integrations';
export const ACCESS_LOGS_INTEGRATIONS_CONFIG = 'access-logs-integrations';

export const ALERT_CHAT_APP_NOTIFICATIONS = 'alert-notifications';
export const NON_TARGETED_ALERT_CONFIGURATION = 'non-targeted-alert-configuration';
export const NON_TARGETED_ALERT_CHAT_APP_NOTIFICATIONS = 'strategic-chat-apps-notifications';

export const SSO_CONFIGURATIONS = 'sso-configurations';
// account & customer
export const USERS = 'users';
export const USER_MANAGEMENT = USERS; // 'user-management';
export const USER_CREATE = 'create';
export const MY_PROFILE = 'myProfile';
export const USER_LOGIN_EVENTS = 'user-login-events';
export const ASM_CONFIGURATION = 'asm-configuration';
export const VALIDATION_AND_SCOPING = 'validation-and-scoping';
export const ACTIVE_VULNERABILITY_SCAN = 'active-exposure-validation';
export const ASM_AEV = ACTIVE_VULNERABILITY_SCAN;
export const INTEGRATIONS = 'integrations';
export const PHISHING_BEACON_CONFIGURATION = 'phishing-beacon-configuration';
export const PHISHING_BEACON_TESTER = 'phishing-beacon-tester';

export const WHITE_LABEL_CONFIG_PAGE = 'theme-settings';
export const ENV_INSIGHTS = 'env-insights';
export const SUMMARY = 'summary';
export const PHISHING_DETAILS = 'phishing-details';
export const ENV_INSIGHTS_SUMMARY = `${ENV_INSIGHTS}/${SUMMARY}`;
export const ENV_INSIGHTS_PHISHING_DETAILS = `${ENV_INSIGHTS}/${PHISHING_DETAILS}`;
export const LICENSE_MANAGEMENT = 'license-management';
export const RESEARCH_NEWS_FEED_TAB = 'security-news';

//* **** START under the "/card" path */
export const THREAT_ACTOR = 'threat-actor';
export const MALWARE = 'malware';
export const CVE = 'cve';
//* **** END under the "/card" path */

export const ASSET_MGMT = 'assets-management';

export const EXPANDED_COMMENTS_PARAM = 'expand_comments';
